export default __webpack_public_path__ + "static/media/loadingbrain-blue.9a8932a6.svg";